export default __webpack_public_path__ + "static/media/img14.fd9282d1.PNG";